import { useCallback, useEffect, useRef, useState } from 'react';

export const useTicker = ({
  startDelay = 3000,
  msgId,
  scrollSpeed,
  animatedPositionX,
  contentRef,
}) => {
  const [startTicker, setStartTicker] = useState(false);

  const currentOffsetRef = useRef(0);
  const animationIdRef = useRef(null);
  const prevIdRef = useRef(msgId);

  const lastTimestampRef = useRef(null);

  useEffect(() => {
    const timer = setTimeout(() => {
      setStartTicker(true);
    }, startDelay);

    return () => clearTimeout(timer);
  }, [startDelay]);

  useEffect(() => {
    if (prevIdRef.current !== msgId) {
      if (animationIdRef.current) {
        cancelAnimationFrame(animationIdRef.current);
        animationIdRef.current = null;
      }

      if (contentRef.current) {
        contentRef.current.style.transform = 'translateX(0px)';
      }
      currentOffsetRef.current = 0;

      setStartTicker(false);
      const timer = setTimeout(() => {
        setStartTicker(true);
      }, startDelay);

      prevIdRef.current = msgId;

      return () => clearTimeout(timer);
    }
  }, [msgId, startDelay]);

  const animate = useCallback(
    (timestamp) => {
      if (!contentRef.current) {
        if (animationIdRef.current) {
          cancelAnimationFrame(animationIdRef.current);
          animationIdRef.current = null;
        }
        return;
      }

      if (!lastTimestampRef.current) {
        lastTimestampRef.current = timestamp;
      }

      const deltaTime = (timestamp - lastTimestampRef.current) / 1000;
      lastTimestampRef.current = timestamp;

      currentOffsetRef.current += scrollSpeed * deltaTime;

      const newPosition = currentOffsetRef.current;

      contentRef.current.style.transform = `translateX(${-newPosition}px)`;

      if (newPosition < Math.abs(animatedPositionX)) {
        animationIdRef.current = requestAnimationFrame(animate);
      } else {
        if (animationIdRef.current) {
          cancelAnimationFrame(animationIdRef.current);
          animationIdRef.current = null;
        }
        setStartTicker(false);
      }
    },
    [scrollSpeed, animatedPositionX]
  );

  useEffect(() => {
    if (startTicker) {
      if (animationIdRef.current) {
        cancelAnimationFrame(animationIdRef.current);
      }
      animationIdRef.current = requestAnimationFrame(animate);
    } else {
      if (animationIdRef.current) {
        cancelAnimationFrame(animationIdRef.current);
        animationIdRef.current = null;
      }
    }

    return () => {
      if (animationIdRef.current) {
        cancelAnimationFrame(animationIdRef.current);
        animationIdRef.current = null;
      }
    };
  }, [startTicker, animate, animatedPositionX]);

  return {};
};
